import React, { Component } from 'react';
import Toast from './Toast';

class ToastContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toasts: [],
    };
  }

  addToast = (message, type = 'info') => {
    const id = Math.random().toString(36).substring(2, 9);
    this.setState((prevState) => {
      return { toasts: [...prevState.toasts, { id, message, type }] };
    });
  };

  removeToast = (id) => {
    this.setState((prevState) => ({
      toasts: prevState.toasts.filter((toast) => toast.id !== id),
    }));
  };

  render() {
    return (
      <div className="toast-container">
        {this.state.toasts.map((toast) => (
          <Toast
            key={toast.id}
            id={toast.id}
            message={toast.message}
            type={toast.type}
            removeToast={this.removeToast}
          />
        ))}
      </div>
    );
  }
}

export default ToastContainer;
